import React, { FunctionComponent, useEffect } from 'react';

import { CommonError } from 'src/components/common-error';
import { i18n } from 'src/i18n';
import { monkeyImageProps } from 'src/resources/images';
import { selectErrors } from 'src/state/errors/selectors';
import { useAppDispatch, useAppSelector } from 'src/state/thunk-api';
import { DataLayerEcomErrors } from 'src/types/data-layer-event-object';

import { useResetState } from './hooks/use-reset-state';

export const PageError: FunctionComponent = () => {
  const globalErrors = useAppSelector(selectErrors);
  const { resetState } = useResetState();
  const dispatch = useAppDispatch();

  useEffect(
    () => () => {
      // This is a bit heavy-handed, but resetting everything allows us to guarantee a clean state
      resetState();
    },
    [dispatch, globalErrors, resetState],
  );

  return (
    <CommonError
      title={i18n.page.error.generic.title}
      subtitles={i18n.page.error.generic.subtitle}
      image={monkeyImageProps}
      dataLayerErrorMessage={DataLayerEcomErrors.GENERIC_ERROR}
    />
  );
};
